import { render, staticRenderFns } from "./ConfirmationButtons.vue?vue&type=template&id=678277e8&"
import script from "./ConfirmationButtons.vue?vue&type=script&lang=js&"
export * from "./ConfirmationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports